/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CourseModuleAssessmentItemsInnerStats360FeedbackInner { 
    /**
     * 
     */
    amount: number;
    /**
     * 
     */
    status: CourseModuleAssessmentItemsInnerStats360FeedbackInner.StatusEnum;
}
export namespace CourseModuleAssessmentItemsInnerStats360FeedbackInner {
    export type StatusEnum = 'invited' | 'assessed';
    export const StatusEnum = {
        Invited: 'invited' as StatusEnum,
        Assessed: 'assessed' as StatusEnum
    };
}


